import axios from 'axios'

const axiosInstanceGudId = axios.create({
  baseURL: process.env.REACT_APP_GUDID_URL,
  timeout: 8000,
})

const axiosInstanceIservices = axios.create({
  baseURL: process.env.REACT_APP_ISERVICES_BASE_URL,
  timeout: 8000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const axiosInstanceReports = axios.create({
  baseURL: process.env.REACT_APP_REPORTS_URL + 'api/v1',
  timeout: 8000,
})

const axiosInstanceWallet = axios.create({
  baseURL: process.env.REACT_APP_WALLET_API_URL,
  timeout: 8000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const axiosInstanceTracking = axios.create({
  baseURL: process.env.REACT_APP_TRACKING_API_URL || 'http://3.17.10.216:8000',
  timeout: 30000, // Longer timeout for image processing
  headers: {
    'Content-Type': 'application/json',
  },
})

export {
  axiosInstanceGudId,
  axiosInstanceIservices,
  axiosInstanceReports,
  axiosInstanceWallet,
  axiosInstanceTracking,
}
